import { Form } from "react-bootstrap";
import { toast } from "react-toastify";
import Select from "react-select";
import {
  FiBriefcase,
  FiPhone,
  FiMapPin,
} from "react-icons/fi";
import CountryCodeDirectionPicker from "../country-code-direction/CountryCodeDirectionPicker";

function IconField({ icon: Icon, iconTop, children }) {
  return (
    <div className={`ccf-input-with-icon${iconTop ? " ccf-input-with-icon--textarea" : ""}`}>
      <span className="ccf-input-with-icon__icon">
        <Icon size={18} />
      </span>
      {children}
    </div>
  );
}

export default function RenderUserCompanyFields(props) {
  return (
    <div className="company-basic-fields">
      <div className="row g-3">
        <Form.Group className="col-12 col-lg-4 form-group mb-0">
          <Form.Label htmlFor="company_name">
            Company Name
            <span className="text-danger ms-1">*</span>
          </Form.Label>
          <IconField icon={FiBriefcase}>
            <Form.Control
              type="text"
              id="company_name"
              className="ccf-input-with-icon__control"
              placeholder="Enter company name"
              maxLength={100}
              value={props.company_name}
              onChange={(e) => {
                const value = e.target.value;
                if (!/^[a-zA-Z0-9 ]*$/.test(value)) {
                  toast.warning("Special characters are not allowed in company name", {
                    toastId: "company-name-special-char",
                  });
                  return;
                }
                props.set_company_name(value);
              }}
              required
            />
          </IconField>
        </Form.Group>

        <Form.Group className="col-12 col-lg-4 form-group mb-0">
          <Form.Label htmlFor="company_phone">
            Phone
            <span className="text-danger ms-1">*</span>
          </Form.Label>
          <IconField icon={FiPhone}>
            <Form.Control
              type="tel"
              id="company_phone"
              className="ccf-input-with-icon__control"
              placeholder="10 digits"
              value={props.company_phone}
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, "");
                if (value.length > 10) {
                  toast.warning("Phone number cannot be more than 10 digits");
                  return;
                }
                props.set_company_phone(value);
              }}
              required
            />
          </IconField>
        </Form.Group>

        <Form.Group className="col-12 col-lg-4 form-group mb-0">
          <Form.Label htmlFor="company_pincode">
            Pincode
            <span className="text-danger ms-1">*</span>
          </Form.Label>
          <IconField icon={FiMapPin}>
            <Form.Control
              type="text"
              inputMode="numeric"
              pattern="[0-9]*"
              id="company_pincode"
              className="ccf-input-with-icon__control"
              placeholder="6 digits"
              value={props.company_pincode}
              onChange={(e) => {
                const onlyDigits = e.target.value.replace(/\D/g, "");
                if (onlyDigits.length <= 6) {
                  props.set_company_pincode(onlyDigits);
                }
              }}
              onPaste={(e) => {
                const pasted = e.clipboardData.getData("text").replace(/\D/g, "");
                e.preventDefault();
                props.set_company_pincode(pasted.slice(0, 6));
              }}
              required
            />
          </IconField>
        </Form.Group>
      </div>

      <div className="row g-3 mt-0">
        <Form.Group className="col-12 col-lg-4 form-group mb-0">
          <Form.Label htmlFor="company_address">
            Company Address
            <span className="text-danger ms-1">*</span>
          </Form.Label>
          <IconField icon={FiMapPin} iconTop>
            <Form.Control
              as="textarea"
              rows={2}
              id="company_address"
              className="ccf-input-with-icon__control"
              placeholder="Street, city, state"
              maxLength={500}
              value={props.company_address}
              onChange={(e) => props.set_company_address(e.target.value)}
              required
            />
          </IconField>
        </Form.Group>

        {props.locations && (
          <Form.Group className="col-12 col-lg-4 form-group mb-0">
            <Form.Label>Location</Form.Label>
            <IconField icon={FiMapPin}>
              <Select
                className="theme-react-select ccf-select-in-icon"
                classNamePrefix="theme-react-select"
                options={props.locations}
                value={props.locations.filter((l) =>
                  props.selectedLocation.includes(l.value)
                )}
                onChange={(selected) =>
                  props.setSelectedLocation(selected.map((s) => s.value))
                }
                isMulti
                placeholder="Select Location"
              />
            </IconField>
          </Form.Group>
        )}

        {props.countryCodeDirections && (
          <div className="col-12 col-lg-4">
            <CountryCodeDirectionPicker
              items={props.countryCodeDirections}
              selectedIds={props.selectedCountryCodeDirections}
              onChange={props.setSelectedCountryCodeDirections}
              label="Country Codes"
              placeholder="Select country code"
              groupClassName="form-group mb-0"
              iconWrap
            />
          </div>
        )}
      </div>
    </div>
  );
}
